import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login, sendOtp } from "../api/menupro.api";
import { setBusiness } from "../store/menupro.store";
import "./auth.css";

export default function Login() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [banner, setBanner] = useState(null); // {type:'error'|'info', text:string}
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    setBanner(null);

    if (!phone || !password) {
      setBanner({ type: "error", text: "Telefon və şifrə daxil edin." });
      return;
    }

    try {
      setLoading(true);
      const res = await login({ phone, password });
      setBusiness(res.data);
      navigate("/menupro/dashboard");
    } catch (e) {
      const data = e?.response?.data;
      const msg = (typeof data === "string" ? data : data?.message) || e?.message || "";
      const s = String(msg).toUpperCase();

      // ✅ phone not verified
      if (s.includes("PHONE_NOT_VERIFIED") || s.includes("VERIFY")) {
        setBanner({ type: "info", text: "Telefon təsdiqlənməyib. OTP göndərildi." });
        try { await sendOtp(phone); } catch { }
        navigate(`/menupro/verify?phone=${encodeURIComponent(phone)}&password=${encodeURIComponent(password)}`);
        return;
      }

      // ✅ approval pending
      if (s.includes("APPROVAL_PENDING") || s.includes("PENDING")) {
        setBanner({ type: "info", text: "Sorğunuz gözləmədədir. Admin təsdiqləyəndə giriş açılacaq." });
        navigate(`/menupro/waiting/${encodeURIComponent(phone)}`);
        return;
      }

      // ✅ rejected
      if (s.includes("APPROVAL_REJECTED") || s.includes("REJECTED")) {
        setBanner({ type: "error", text: "Sorğunuz rədd edilib. Adminlə əlaqə saxlayın." });
        navigate(`/menupro/waiting/${encodeURIComponent(phone)}`);
        return;
      }

      // ✅ inactive
      if (s.includes("ACCOUNT_INACTIVE") || s.includes("INACTIVE")) {
        setBanner({ type: "error", text: "Hesab deaktivdir." });
        return;
      }

      // ❌ default
      setBanner({ type: "error", text: msg || "Telefon və ya şifrə yanlışdır." });
    }

    finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">MenuPro</h1>
        <p className="auth-subtitle">Biznes panelinə giriş</p>

        {banner && (
          <div className={`auth-banner ${banner.type}`}>
            {banner.text}
          </div>
        )}

        <input
          className="auth-input"
          placeholder="Telefon nömrəsi"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <input
          className="auth-input"
          type="password"
          placeholder="Şifrə"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="auth-button" onClick={handleLogin} disabled={loading}>
          {loading ? "Daxil olunur..." : "Daxil ol"}
        </button>

        <p className="auth-link">
          Hesabın yoxdur? <Link to="/menupro/register">Qeydiyyat</Link>
        </p>
      </div>
    </div>
  );
}

